'use strict';

var blockBranding = blockBranding || {};
var $ = jQuery;

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
blockBranding.init = function () {
  blockBranding.sliceTitle();
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(blockBranding.init);

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
blockBranding.sliceTitle = function () {

  var siteName = $('.site-name')
  var html = siteName.html();
  html = html.replace(/((\w+\W+){1})/, '$1<br/>');
  siteName.html(html);

};